import React, { ReactNode, useState, useCallback } from "react";
import styled from "styles/styled_components";

import Icon, { ICON_TYPE } from "components/shared/icon";
import Tooltip, {
  POINTER_SIZE,
  TOOLTIP_WIDTHS,
} from "components/shared/tooltip";

const StyledWrapper = styled.div`
  position: relative;
  & > div {
    position: absolute;
    left: calc(100% + ${POINTER_SIZE + 10}px);
    top: 8px;
    transform: translateY(-50%);
    z-index: ${(props) => props.theme.layering.overlay};
  }
`;

interface IInfoTooltip {
  children: ReactNode;
  className?: string;
  size?: string;
  width?: TOOLTIP_WIDTHS;
}

function InfoTooltip({
  children,
  className,
  size,
  width = TOOLTIP_WIDTHS.small,
}: IInfoTooltip) {
  const [isHovered, setIsHovered] = useState(false);
  const showHover = useCallback(() => setIsHovered(true), [setIsHovered]);
  const hideHover = useCallback(() => setIsHovered(false), [setIsHovered]);
  return (
    <StyledWrapper className={className}>
      <Icon
        type={ICON_TYPE.INFO_CIRCLE}
        onMouseEnter={showHover}
        onMouseLeave={hideHover}
        size={size}
      />
      {isHovered && (
        <Tooltip pointer="left" width={width}>
          {children}
        </Tooltip>
      )}
    </StyledWrapper>
  );
}

export default InfoTooltip;
